import { ActionIcon, Group, Menu } from "@mantine/core";
import { IconDotsVertical, IconReplace, IconTrashFilled } from "@tabler/icons-react";
import type { FC } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import type { Tileset, TilesetVersion } from "../types/tileset";
import { useDisclosure } from "@mantine/hooks";
import { DeleteVersionModal } from "./DeleteVersionModal";
import { SetTilesetVersionModal } from "./SetTilesetVersionModal";

interface VersionItemControlsProps {
  tileset: Tileset;
  version: TilesetVersion;
}

export const VersionItemControls: FC<VersionItemControlsProps> = ({ tileset, version }) => {
  const {
    currentVersionId,
  } = tileset;

  const {
    id: versionId,
  } = version;

  const intl = useIntl();

  const [
    deleteModalOpened, {
      open: openDeleteModal,
      close: closeDeleteModal,
    },
  ] = useDisclosure(false);

  const [
    setModalOpened, {
      open: openSetModal,
      close: closeSetModal,
    },
  ] = useDisclosure(false);

  const label = intl.formatMessage({
    defaultMessage: "Options",
    id: "label.options",
  });

  if (currentVersionId === versionId) {
    return null;
  }

  return (
    <Group gap="xs">
      <Menu shadow="md" width={200} position="bottom-end">
        <Menu.Target>
          <ActionIcon aria-label={label} variant="default" h={32}>
            <IconDotsVertical stroke={1.5} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            leftSection={<IconTrashFilled size={16} />}
            onClick={openDeleteModal}
          >
            <FormattedMessage defaultMessage="Delete" id="label.delete" />
          </Menu.Item>

          <Menu.Item
            leftSection={<IconReplace size={16} />}
            onClick={openSetModal}
          >
            <FormattedMessage defaultMessage="Set as current" id="label.setAsCurrent" />
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      <DeleteVersionModal
        open={deleteModalOpened}
        onClose={closeDeleteModal}
        tileset={tileset}
        version={version}
      />

      <SetTilesetVersionModal
        open={setModalOpened}
        onClose={closeSetModal}
        tileset={tileset}
        version={version}
      />
    </Group>
  );
};
